import { makeStyles, css, theme } from '@conexasaude/hero'

const useStyles = makeStyles({
  confirmGroupConsultationWrapper: ({ colors }) => css`
    h2 {
      font-size: 24px;
      color: ${theme.colors.neutral[900]};
      font-weight: bold;
      line-height: 32px;
      margin-bottom: 8px;
      margin-top: 16px;
      @media (min-width: 640px) {
        font-size: 32px;
        font-weight: 800;
        line-height: 48px;
      }
    }
    .main-wrapper {
      display: flex;
      margin-top: 40px;
      flex-direction: column;
      align-items: center;
      text-align: center;

      span {
        margin-bottom: 35px;
        @media (min-width: 640px) {
          max-width: 430px;
          margin-bottom: 48px;
        }
      }
    }
    h5.abstract-title {
      font-size: 20px;
      color: ${theme.colors.neutral[900]};
      margin-top: 30px;
      font-weight: bold;
      line-height: 32px;
    }
    .details-section {
      border: 1px solid #dadee2;
      border-radius: 8px;
      font-size: 16px;
      padding: 16px;
      margin: 16px 0 16px 0;
      flex-grow: 1;

      }
      span {
        color: ${colors.neutral[900]};
        font-weight: 600;
      }
    }
    section {
      display: flex;
      align-items: center;
      margin: 16px 0 0 0;

      :last-child {
        color: ${colors.neutral[900]};
        font-weight: 600;
        font-size: 16px;
      }
    }
    .abstract-wrapper {
      width: 70%;
      height: 30%;
      @media (min-width: 640px) {
        display: flex;
        flex-direction: row;
        gap: 16px;
      }
    }
    .link-footer {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }
    span.hero-link__label {
      color: ${colors.primary[500]};
      font-weight: 700, bold;
    }
    `,
  backLink: () => css`
    > svg {
      margin-right: 12px;
    }
  `,
})

export default useStyles
